import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Palestine: Country = {
    identifier: "Palestine",
    name: "Palestine",
    countryCode: "PS",
    group: CountryGroup.ASIA,
    isUNMember: false,
    flag: "🇵🇸",
    svgPath: "m 571.29375,370.9354 -0.289,0.276 -0.092,-0.274 -0.041,-0.099 0.531,-0.527 0.253,-0.332 0.131,0.142 0.004,0.053 -0.492,0.533 -0.005,0.228 z m 3.32,-2.27 0.077,0.722 -0.167,0.306 -0.095,0.361 -0.042,0.272 -0.117,-0.012 -0.371,0.197 -0.493,0.186 -0.542,0.048 -0.077,-0.055 -0.022,-0.094 0.159,-0.458 0.061,-0.215 0.235,-0.232 0.333,-0.201 0.141,-0.051 -0.016,-0.086 -0.199,-0.133 -0.208,-0.069 -0.197,0.069 -0.062,-0.021 -0.021,-0.059 0.069,-0.083 0.032,-0.154 -0.031,-0.258 -0.021,-0.314 -0.043,-0.244 0.123,-0.396 0.031,-0.189 0.153,-0.404 0.359,-0.245 0.311,0.071 0.164,0.018 0.069,0.048 0.045,0.14 0.229,0.162 0.188,0.021 0.058,0.521 -0.105,0.445 -0.008,0.386 z",
}
